// extracted by mini-css-extract-plugin
export default {"pageWrapper":"style_pageWrapper__uDmxd","componentWrapper":"style_componentWrapper__vCS+t"};